import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

const ImageModal = ({ imageUrl, onClose }) => {
  const isOpen = !!imageUrl; // ✅ modal open only if imageUrl exists

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>Image Preview</ModalHeader>
      <ModalBody className="text-center">
        <img
          src={imageUrl}
          alt="Full View"
          className="img-fluid rounded shadow-lg"
          style={{ maxHeight: "80vh" }}
        />
      </ModalBody>
      <div className="modal-footer">
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default ImageModal;
